import Vue from 'vue';
import Vuex from 'vuex';
import me from '@/store/me';
import auth from '@/store/auth';
import apiMessage from '@/store/apiMessage';

Vue.use(Vuex);

// eslint-disable-next-line
export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        me,
        auth,
        apiMessage,
    },
});
